export const setPassword = value => {
  localStorage.setItem('password', value);
};

export const clearPassword = () => {
  localStorage.clear('password');
};

export const getPassword = () => localStorage.getItem('password') || '';
